import React from 'react';

export default function CircularTick() {
  return (
    <svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1">
      <g id="tick" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M9,0 C4.032,0 0,4.032 0,9 C0,13.968 4.032,18 9,18 C13.968,18 18,13.968 18,9 C18,4.032 13.968,0 9,0 Z M7.2,13.5 L2.7,9 L3.969,7.731 L7.2,10.953 L14.031,4.122 L15.3,5.4 L7.2,13.5 Z"
          fill="#40DDC6"></path>
      </g>
    </svg>
  );
}
